import { render, staticRenderFns } from "./ExpressInfo.vue?vue&type=template&id=4402abd6&scoped=true"
import script from "./ExpressInfo.vue?vue&type=script&lang=ts"
export * from "./ExpressInfo.vue?vue&type=script&lang=ts"
import style0 from "./ExpressInfo.vue?vue&type=style&index=0&id=4402abd6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4402abd6",
  null
  
)

export default component.exports